import PropTypes from 'prop-types'
import { Button, IconStarActive, IconStarDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

const Rate = ({ isActive, onMouseEnter, onMouseLeave, ...props }) => {
  const { t } = useTranslation('@mc/next')

  return (
    <Button
      kind='link'
      className='mc-p-0 mc-mx-1'
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...props}
    >
      {isActive ? (
        <IconStarActive
          size='lg'
          srText={t('article.subsections.recipe.starFilled')}
          className='mc-text--highlight'
        />
      ) : (
        <IconStarDefault
          size='lg'
          srText={t('article.subsections.recipe.star')}
        />
      )}
    </Button>
  )
}

Rate.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
}

export default Rate
